<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'base.copy_load' | translate }}
    v-card-content
      v-select(
        :label="'base.periods' | translate"
        :options="loadings"
        v-model="form.loading")
    v-card-actions
      v-btn(
        :loading="loading"
        @click="onCreate") {{ 'base.copy' | translate }}
</template>

<script>
import api from '@/api'

export default {
  name: 'CreateRationCopyModal',

  props: {
    rationId: Number
  },

  data: () => ({
    loadings: [],
    form: {
      loading: null
    },
    loading: false
  }),

  mounted () {
    this.fetchLoadings()
  },

  methods: {
    async onCreate () {
      if (this.form.loading) {
        this.loading = true
        const { data } = await api.schedule.getById(this.rationId)
        data.schedule_loading = { loading: this.form.loading }
        const res = await api.schedule.create(data)
        this.loading = false
        if (!res.errors) {
          this.$store.dispatch('updatePeriods')
          this.$emit('update')
          this.$emit('close')
        } else {
          this.$toasted.show(this.$t('errors.unexpected'))
        }
      }
    },

    async fetchLoadings () {
      const params = {
        farm: this.$route.params.farm_id,
        deleted: 'false'
      }
      const { data } = await api.loadings.list(params)
      this.loadings = data
      const id = +this.$route.query.loading
      const selectedLoading = this.loadings.find(item => item.id === id) || this.loadings[0]
      this.form.loading = selectedLoading ? selectedLoading.id : null
    }
  }
}
</script>
